import { fork } from 'redux-saga/effects';
import { accountSagas } from "../modules/Account/accountSagas";
import { bonusesSagas } from "../modules/Bonus/bonusesSagas.js";
import { googleTagManagerSagas } from "../modules/GoogleTagManager/googleTagManagerSagas";
import { loginSagas } from "../modules/Login/loginSagas";
import { mobileBonusSagas } from "../modules/MobileBonus/mobileBonusSagas";
import { partnerSagas } from "../modules/Partner/partnerSagas";
import { appSagas } from "./appSagas";
import { notificationsSagas } from "../modules/Notifications/notificationsSagas";

export function* coreSagas() {
    yield fork(accountSagas);
    yield fork(appSagas);
    yield fork(bonusesSagas);
    yield fork(googleTagManagerSagas);
    yield fork(loginSagas);
    yield fork(mobileBonusSagas);
    yield fork(notificationsSagas);
    yield fork(partnerSagas);
}
